import { sendUtagEvent } from '../../core/analytics/utag_events'
import on from '../../utils/events_delegation'

export function initializeUtagEvents() {
  const event_name = 'last_search'
  const event_cat = 'last search'
  let event_act = ''
  let event_lbl = ''
  let event_purpose = ''
  let event_structure = ''

  const eventZone = target => {
    return target.closest('.main-nav') !== null ||
      target.closest('.main-header-cnt') !== null ||
      target.closest('.panel-content') !== null ||
      target.closest('.burgermenu-panel') !== null ||
      target.closest('.main-nav') ||
      target.closest('.mobile-last-searches') ||
      document.body.classList.contains('nhp-home')
      ? 'header'
      : 'body'
  }

  const eventLabel = target => {
    return target.closest('.main-nav') !== null ||
      target.closest('.main-header-cnt') !== null ||
      target.closest('.panel-content') !== null
      ? 'top menu'
      : 'body'
  }

  on({
    eventName: 'click',
    selector: '.utag-last-search-card',
    handler(event) {
      const target = event.target
      const event_zone = eventZone(target)

      /* Evento ver las últimas búsquedas */
      if (target.matches('.utag-last-search-card .utag-last-search-view-search')) {
        event_act = 'see last search'
        event_purpose = 'booking'
        event_structure = event_zone
        event_lbl = event_zone
      }

      /* Evento compartir últimas búsquedas */
      if (target.matches('.utag-last-search-card .utag-last-search-shared')) {
        event_act = 'share last search'
        event_lbl = eventLabel(target)
        event_purpose = 'loyalty'
        event_structure = event_zone
      }

      /* Evento enviar últimas búsquedas */
      if (target.matches('.utag-shared-last-search-form .utag-share-last-search-email')) {
        event_act = 'send last search'
        event_lbl = 'mail'
        event_purpose = 'booking'
        event_structure = 'popup'
      }

      if (!event_act.length) return
      sendUtagEvent({
        data: {
          event_name,
          event_cat,
          event_act,
          event_lbl,
          event_purpose,
          event_structure,
        },
      })
    },
  })

  on({
    eventName: 'click',
    selector: '.utag-shared-last-search-form .utag-share-last-search-email',
    handler() {
      /* Evento enviar últimas búsquedas */
      event_act = 'send last search'
      event_lbl = 'mail'
      event_purpose = 'booking'
      event_structure = 'popup'

      if (!event_act.length) return
      sendUtagEvent({
        data: {
          event_name,
          event_cat,
          event_act,
          event_lbl,
          event_purpose,
          event_structure,
        },
      })
    },
  })
}
